import { render, staticRenderFns } from "./TabelaDominios.vue?vue&type=template&id=43b880bf"
import script from "./TabelaDominios.vue?vue&type=script&lang=js"
export * from "./TabelaDominios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports